export default "__VITE_ASSET__uGQOJVsV__"